export default __webpack_public_path__ + "static/media/logo_azul.4c32d02a.png";